module.exports = __webpack_public_path__ + "media/invite-a-friend/send-invites-55734076.png";